"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanProjection = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var copy_1 = require("../../../../../copy");
var utils_1 = require("../../../../../utils");
var PlanProjection = function (_a) {
    var recommendedDirectDebit = _a.recommendedDirectDebit, isDebtRisk = _a.isDebtRisk, hasValidRecommendation = _a.hasValidRecommendation, hasProblematicRecommendationStatus = _a.hasProblematicRecommendationStatus, directDebitAmount = _a.directDebitAmount, directDebitDay = _a.directDebitDay;
    var Margin = (0, core_1.useComponents)().Margin;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if (isDebtRisk ||
        hasProblematicRecommendationStatus ||
        !hasValidRecommendation) {
        return null;
    }
    var formattedDirectDebit = parseFloat(directDebitAmount.amount) - parseInt(directDebitAmount.amount) >
        0
        ? (0, core_1.absoluteMajor2DP)((0, core_1.majorToMinor)(directDebitAmount.amount))
        : (0, core_1.absoluteMajor0DP)((0, core_1.majorToMinor)(directDebitAmount.amount));
    var predictedFinalBalance = recommendedDirectDebit.predictedFinalBalance, calculationEndDate = recommendedDirectDebit.calculationEndDate;
    var formattedPredictedFinalBalance = (0, core_1.major0DP)((0, core_1.majorToMinor)(predictedFinalBalance.amount, predictedFinalBalance.currencyUnit));
    var formattedDate = (0, date_fns_1.format)(calculationEndDate, 'd MMMM yyyy');
    var projectionCopyKey = parseInt(predictedFinalBalance.amount, 10) >= 0
        ? 'changeDirectDebitPlanProjectionEstimatedPositive'
        : 'changeDirectDebitPlanProjectionEstimatedNegative';
    var finalBalanceState = (0, utils_1.getPredictedFinalBalanceState)(parseInt(predictedFinalBalance.amount, 10));
    var amount = formattedDirectDebit;
    var day = directDebitDay
        ? (0, date_fns_1.format)(new Date(1970, 0, directDebitDay), 'do')
        : '';
    var truingCopy = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Copy, { copyKey: "directDebitAmountWithDay", values: {
                amount: amount,
                day: day,
            } }),
        finalBalanceState === 'onTrack' ? (react_1.default.createElement(Copy, { copyKey: "directDebitOnTrack" })) : (react_1.default.createElement(Copy, { copyKey: projectionCopyKey, props: { formattedPredictedFinalBalance: formattedPredictedFinalBalance }, values: { formattedDate: formattedDate } }))));
    return (react_1.default.createElement(Margin, { bottom: 4, top: 6, "data-testid": "plan-projection" }, truingCopy));
};
exports.PlanProjection = PlanProjection;
